import { useChallenges } from '../../../redux/reducer/content';
import { isArray } from 'lodash';

export default function useGetFullAchievementsList() {
  const { icons } = useChallenges();

  return (iconsList = icons) => {
    const fullList = [];

    recurse(iconsList);

    function recurse(list) {
      list.forEach((item) => {
        fullList.push(item);
        isArray(item.child) && recurse(item.child);
      });
    }

    return fullList;
  };
}
